import Vue from "vue";
import IframeSizer from "@/plugins/iframesizer";

describe("IframeSizer plugin", () => {
  let autoResizeMock;

  beforeEach(() => {
    autoResizeMock = jest.fn();
    global.window.parentIFrame = { autoResize: autoResizeMock };
    Vue.use(IframeSizer);
  });

  afterEach(() => {
    delete global.window.parentIFrame;
  });

  it("should call autoResize when mounted", () => {
    const vm = new Vue({
      template: "<div></div>"
    }).$mount();

    expect(autoResizeMock).toHaveBeenCalled();

    vm.$destroy();
  });
});
